export enum CalendarLangEnum {
    FR = "fr",
    GB = "enGB",
    ES = "es",
}
